import { Typography } from '@banhala/ui-kit';

export const StandardOptionBadge = () => (
  <Typography type={'subtitle4'} color={'content_tertiary'}>
    일반배송
  </Typography>
);
